import { makeStyles } from "@mui/styles";
import { COLORS } from "../../../v3/Theme/colors.js";

const TestResultsPageStyles = makeStyles((theme) => ({
  container: {
    paddingTop: "70px",
    paddingBottom: "50px"
  },
  section: {
    marginTop: "90px"
  },
  breadcrumbs: {
    marginTop: "10px",
    marginBottom: "30px",
    "& a": {
      textDecoration: "none"
    }
  },
  faqAccordian: {
    border: "none",
    boxShadow: "none",
    "&:before": {
      backgroundColor: COLORS.SECONDARY
    },
    "& .MuiPaper-root": {
      border: "none",
      boxShadow: "none",
      borderBottomColor: "black"
    },
    "& .MuiSvgIcon-root": {
      fontSize: "30px"
    },
    "& .MuiAccordionSummary-root": {
      padding: 0
    },
    "& .MuiAccordionSummary-content": {
      margin: "25px 0 25px 0"
    }
  },
  sideMenuContainer: {
    paddingRight: "20px"
  },
  sideMenu: {
    backgroundColor: COLORS.PRIMARY_LIGHTEST,
    borderRadius: "10px",
    padding: "30px",
    position: "sticky",
    top: 0,
    "& a": { color: "inherit" }
  },
  whatsNextHeader: {
    borderBottom: `1px solid ${COLORS.LIGHT_GRAY}`,

    paddingBottom: "13px"
  },
  whatsNextArrow: {
    fontSize: "18px",
    position: "relative",
    top: "2px"
  },
  riskAssessmentContainer: {
    backgroundColor: COLORS.ACCENT1_LIGHTEST,
    border: `3px solid ${COLORS.ACCENT1_LIGHTER}`,
    borderRadius: "32px 8px 32px 32px",
    padding: "30px",
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4)
  },
  resultIcon: {
    padding: "20px",
    marginRight: theme.spacing(2),
    verticalAlign: "middle"
  },
  resultDescription: {
    marginTop: theme.spacing(2),
    display: "block"
  },
  nextActions: {
    marginTop: "0px",
    "& .MuiGrid-item": {
      marginTop: "-7px",
      paddingTop: "14px",
      "&:first-of-type": {
        marginTop: 0
      }
    }
  },
  actionIcon: {
    width: "75px",
    height: "75px"
  },
  faqLink: {
    color: COLORS.BLACK,
    textDecoration: "underline",
    cursor: "pointer"
  }
}));

export default TestResultsPageStyles;
